import { getDataLayerByParameters, productsForDataLayer, additionalParametersForDataLayer } from '~/assets/services/dataLayer/dataLayerProducts';
import {
    addProduct as addProductToCart,
    addProductsSet as addProductsSetToCart,
} from '~/assets/services/cart';
import { resolversNames as dataLayerEventsType } from '~/src/plugins/nuxt/dataLayer';

export default {
    async addToCart({ dispatch, rootState }, { id, groupedData, source, qty = 1, withFetch = 1 }) {
        if (!Number.isNaN(qty) && qty > 0) {
            const {
                items,
                qtyAdded,
                success,
                error,
                recommended,
            } = await addProductToCart({ id, qty, source, groupedData });
            let recommendedProductsWithList = {};
            if (withFetch && success) {
                const products = getDataLayerByParameters(rootState.googleServices.products, { id });

                await dispatch('cart2/fetchData', { isLoader: false }, { root: true });
                if (products) {
                    const recommendedProducts = productsForDataLayer(recommended, 'category');
                    const prepareRecommendedProductsForDataLayer = {};
                    Object.keys(recommendedProducts).forEach((key) => {
                        const { sku, brand, name, price, category } = recommendedProducts[key];
                        prepareRecommendedProductsForDataLayer[key] = { id: sku, sku, brand, name, price, category };
                    });
                    recommendedProductsWithList = additionalParametersForDataLayer(prepareRecommendedProductsForDataLayer, {
                        list: 'Rekomendowane produkty',
                    }, true);
                    const dataLayerProducts = { type: 'recommendedProducts', products: prepareRecommendedProductsForDataLayer };
                    dispatch('googleServices/setDataLayerProducts', dataLayerProducts, { root: true });
                    products.quantity = qtyAdded;
                    this.$dataLayer({
                        type: dataLayerEventsType.CART_ADD_ITEM,
                        data: {
                            products,
                            recommended: recommendedProductsWithList,
                        },
                    });
                }
                return ({ items, recommended, productsForDataLayer: recommendedProductsWithList, qtyAdded, success, error });
            }
        }
        return { error: true };
    },
    async addSetToCart({ dispatch }, { setId, productsSet }) {
        const result = await addProductsSetToCart({ setId, productsSet });
        await dispatch('cart2/fetchData', {}, { root: true });
        return result;
    },
};
